import { VIDEO_PLATFORM } from '@lyrahealth-inc/shared-app-logic/src/models/modality/Modality'

import { baseApi, RTKQueryTag } from '../data/baseApi'

type GetVideoSessionPreferenceArgs = {
  id: string
}

type PutVideoSessionPreferenceArgs = {
  id: string
  data: { value: VIDEO_PLATFORM; value_type: string }
}

const settingsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getVideoSessionPreference: builder.query<VIDEO_PLATFORM, GetVideoSessionPreferenceArgs>({
      query: ({ id }) => ({
        method: 'get',
        url: `/v1/providers/property/${id}/videoSessionPreference`,
        ignore404: true,
      }),
      providesTags: [RTKQueryTag.VIDEO_SESSION_PREFERENCE],
    }),
    putVideoSessionPreference: builder.mutation<void, PutVideoSessionPreferenceArgs>({
      query: ({ id, data }) => ({
        method: 'put',
        url: `/v1/providers/property/${id}/videoSessionPreference`,
        data,
      }),
      invalidatesTags: [RTKQueryTag.VIDEO_SESSION_PREFERENCE],
    }),
  }),
})

export const { useGetVideoSessionPreferenceQuery, usePutVideoSessionPreferenceMutation } = settingsApi
